import { faClone } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { CopyToClipboardButton } from '@sorare/core/src/atoms/buttons/CopyToClipboardButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineS, LabelS } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_PLAY_SQUAD } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const Root = styled(Vertical)`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: var(--double-unit);
`;

const Card = styled(Vertical)`
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);
  padding: var(--double-unit);
  width: 100%;
`;

const CodeField = styled(Horizontal)`
  flex: 1;
  background: var(--c-black);
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--unit);
  padding: 10px var(--double-unit);
  justify-content: space-between;
  position: relative;
  padding-right: var(--double-unit);
`;

type Props = {
  joinSecret: string;
  membersCount: number;
  maxMembersCount: number;
};

export const SquadInviteBlock = ({
  joinSecret,
  membersCount,
  maxMembersCount,
}: Props) => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Root gap={2}>
      <SBHorizontal>
        <HeadlineS>
          <FormattedMessage
            id="SquadInviteBlock.title"
            defaultMessage="Invite your friends"
          />
        </HeadlineS>
        <LabelS color="var(--c-nd-600)">
          <FormattedMessage
            id="SquadInviteBlock.memberCount"
            defaultMessage="({membersCount}/{max})"
            values={{ membersCount, max: maxMembersCount }}
          />
        </LabelS>
      </SBHorizontal>
      <Card gap={2}>
        <Horizontal gap={1}>
          <CodeField gap={1}>
            <BodyM color="var(--c-white)">{joinSecret}</BodyM>
            <CopyToClipboardButton textToCopy={joinSecret}>
              <FontAwesomeIcon icon={faClone} color="var(--c-white)" />
            </CopyToClipboardButton>
          </CodeField>
          <Button size="medium" color="secondary">
            <FormattedMessage
              id="SquadInviteBlock.inviteFriends"
              defaultMessage="Invite Friends"
            />
          </Button>
        </Horizontal>
        <Button
          size="large"
          color="primary"
          to={generateSportContextPath(ANY_SPORT_PLAY_SQUAD)}
          fullWidth
        >
          <FormattedMessage
            id="SquadInviteBlock.continue"
            defaultMessage="Continue"
          />
        </Button>
      </Card>
    </Root>
  );
};
